import { Users } from "lucide-react";

interface WhoThisIsForSectionProps {
  description: string;
}

export const WhoThisIsForSection = ({ description }: WhoThisIsForSectionProps) => {
  if (!description) return null;

  return (
    <div className="border-t pt-12 mt-12">
      <div className="flex items-center gap-3 mb-6">
        <Users className="w-8 h-8 text-accent" />
        <h2 className="text-3xl font-bold">Who This Is For</h2>
      </div>
      <div className="prose prose-lg max-w-none">
        <p className="text-lg text-muted-foreground leading-relaxed">{description}</p>
      </div>
    </div>
  );
};
